import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO7.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import flauta from '../../assets/videos/flautanovo.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';     

class EstruturaTO7 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {
             
              $("#TO7desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO7desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO7dimensao").click(function()
        
        {
          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO7video").prop('muted', false);
          $("#TO7dimensao").addClass("todonone");
          $("#TO7dimensao2").removeClass("todonone");
          $("#TO7desapa2").addClass("todonone");
          $("#TO7video").addClass("pulo");

          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          $("#TO8video").prop('muted', true);

          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
          $("#TO6video").prop('muted', true);

          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
          $("#TO5video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
          $("#TO3video").prop('muted', true);

          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
          $("#TO2video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);
      
    
        }
        );
        $("#TO7dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO7video").prop('muted', true);
          $("#TO7dimensao2").addClass("todonone");
          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
        }
        );
    
    
        $("#TO7magazinenova").click(function(){
          $("#TO7desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';
             
              $("#TO7desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO7botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO7hold1 ").addClass("cc");
            $("#TO7botoobras ").addClass("cc");
            $("#TO7hold3 ").addClass("cc");
            $("#TO7hold4 ").addClass("cc");
            $("#TO7hold5 ").addClass("cc");
            $("#TO7hold1 ").removeClass("transiopaca");
            $("#TO7botoobras ").removeClass("transiopaca");
            $("#TO7hold3 ").removeClass("transiopaca");
            $("#TO7hold4 ").removeClass("transiopaca");
            $("#TO7hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO7hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO7hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO7hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO7botoobras ").addClass("transiopaca");
                      $("#TO7hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO7hold1 ").removeClass("cc");
                        $("#TO7botoobras ").removeClass("cc");
                        $("#TO7hold3 ").removeClass("cc");
                        $("#TO7hold4 ").removeClass("cc");
                        $("#TO7hold5 ").removeClass("cc");
                        $("#TO7botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);
        
          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO7desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';
                
                $("#TO7desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO7botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO7boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO7boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO7boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO7boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO7"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO7"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    render() {
        return (
            <div id="TO7obra1" className="displayTO7 gatilhoObra"> {this.props.children}
                <div id="TO7local1"className="videolocalTO7" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3> 2019 - 2020   </h3>
                            <h2 class="sidebar-titulo">FLUTE MAGIQUE  </h2>
                            <p class="descricao">L'œuvre Flauta Magica est présentée comme une flûte qui joue des sons inspirés des sons des étoiles et des planètes et qui apparaissent dans une interface pour l'émerveillement: elle offre au participant la possibilité de jouer une flûte traversière qui, étonnamment, joue des sons créés en combinatoire compositionnelle. (inspiré, à son tour, par les sons de l'espace) à partir d'une base de données - composition de Leonardo Pereira; Pour ce faire, il utilise cette interface de saisie activée à travers les petites majuscules sur les trous de la flûte qui donnent accès à différents champs de la base de données sonores. L'interface de sortie est une boîte en miroir avec de la vapeur d'eau comme une sortie de fumée pour faire rebondir les lumières comme réfraction, agissant comme un kaléidoscope (en cours de finalisation). </p>
                            <a className="botaops"  href="https://editor.p5js.org/10Dimensoes/present/1iDPtKCHz">TRAVAIL INTERACTIF</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>
 
 
 
 
 
 
 
 
                    <div className="tampavideoTO7">
                    </div>
                    <div className="ffechar todonone">
                       <i> FERMER</i>
                    </div>
                    <div className="videoTO7" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO7video" playsInline autoPlay muted loop>
                            <source src={flauta} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO7"></div>
                    <div className="sobrepo2TO7"></div>
                    <div className="sobrepo3TO7"></div>
                </div>
                <div id="TO7desapa" className="magazineTO7">

                 

                </div>
                <div className="magazinenova" id="TO7magazinenova">
                    <div id="TO7dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO7dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO7  ;